import { useState } from "react";

import {
	FrontendBatchType,
	FrontendCompanyTestHierarchyNode,
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleInstance,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { Card } from "@mui/material";
import { FrontendBatchPageTestBatchDetails } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import {
	FrontendCompanyWorkflow,
	FrontendCompanyWorkflowSteps,
} from "node-library/dist/structures/frontendTestWorkflowStructureDefinitions";
import { buildStepTree } from "../../../helpers/workflowHelper";
import { WorkflowStepDataContainer } from "./components/workflowComponents/workflowStepDataContainer";
import { WorkflowStepItem } from "./components/workflowComponents/workflowStepItem";

interface Props {
	user: FrontendUserInfo;
	company: FrontendCompanyWithAdditionalInfomation;
	batchDetails: FrontendBatchPageTestBatchDetails;

	sampleInstances: Array<FrontendSampleInstance>;
	batchType: FrontendBatchType;
	batchVerifyingSampleId: string | undefined;
	reloadBatchDetails: () => void;
}

export default function WorkflowSection(props: Props) {
	const { t: translation } = useTranslation();

	const {
		user,
		company,
		sampleInstances,
		batchType,
		batchVerifyingSampleId,
		batchDetails,
		reloadBatchDetails,
	} = props;

	const currentStepId: string | undefined = batchDetails.currentWorkflowStepId;
	const currentStep: FrontendCompanyWorkflowSteps | undefined =
		batchDetails.workflowStructure?.workflowSteps.find((step) => {
			return step.stepId === currentStepId;
		});
	const [stepToRender, setStepToRender] = useState<
		FrontendCompanyWorkflowSteps | undefined
	>(currentStep);

	const testCategoryNodeParentMap = new Map<
		string,
		Map<string, FrontendCompanyTestHierarchyNode[]>
	>();

	for (const testCategory of company.companyTestCategories) {
		const hierarchyNodeParentMap = new Map<
			string,
			FrontendCompanyTestHierarchyNode[]
		>();

		testCategory.hierarchyNodes.forEach((node) => {
			const parentId = node.parentNodeId || "root";
			if (!hierarchyNodeParentMap.has(parentId))
				hierarchyNodeParentMap.set(parentId, [node]);
			else {
				hierarchyNodeParentMap.get(parentId)!.push(node);
			}
		});
		testCategoryNodeParentMap.set(
			testCategory.testCategoryId,
			hierarchyNodeParentMap,
		);
	}

	const workflowStructure: FrontendCompanyWorkflow =
		batchDetails.workflowStructure as FrontendCompanyWorkflow;

	const stepTree: {
		rootNodes: Array<FrontendCompanyWorkflowSteps>;
		childrenMap: Map<string, Array<FrontendCompanyWorkflowSteps>>;
	} = buildStepTree(workflowStructure.workflowSteps);

	const renderSteps = (
		steps: FrontendCompanyWorkflowSteps[],
		childrenMap: Map<string, Array<FrontendCompanyWorkflowSteps>>,

		level = 0,
	): JSX.Element[] => {
		return steps.map((step) => {
			const children: FrontendCompanyWorkflowSteps[] | undefined =
				childrenMap.get(step.stepId);
			return (
				<div key={step.stepId} style={{ marginLeft: level * 20 }}>
					<WorkflowStepItem
						step={step}
						workflow={workflowStructure}
						currentStep={currentStep}
						renderingStepId={stepToRender?.stepId}
						setStepToRender={setStepToRender}
					/>
					{children &&
						children.length > 0 &&
						renderSteps(children, childrenMap, level + 1)}
				</div>
			);
		});
	};
	const workflowStepsContent: JSX.Element = (
		<Card className="card-small-padding">
			<div className="typography-body-01 typography-bold">
				{translation("TestingWorkflow")}
			</div>
			{renderSteps(stepTree.rootNodes, stepTree.childrenMap)}
		</Card>
	);

	const currentStepComponent: JSX.Element = stepToRender ? (
		<WorkflowStepDataContainer
			user={user}
			currentStep={currentStep as FrontendCompanyWorkflowSteps}
			stepToRender={stepToRender}
			batchDetails={batchDetails}
			company={company}
			reloadBatchDetails={reloadBatchDetails}
			setStepToRender={setStepToRender}
		/>
	) : (
		<></>
	);

	// const instanceCards: Array<React.ReactNode> = sampleInstances
	// 	? sampleInstances.map(
	// 			(sampleInstance: FrontendSampleInstance, index: number) => {
	// 				const categoryId: string = sampleInstance.sample.testCategoryId;
	// 				const testCategory: FrontendCompanyTestCategory =
	// 					company.companyTestCategories.find((category) => {
	// 						return category.testCategoryId === categoryId;
	// 					}) as FrontendCompanyTestCategory;
	// 				const hierarchyNodeParentMap = testCategoryNodeParentMap.get(
	// 					categoryId
	// 				) as Map<string, FrontendCompanyTestHierarchyNode[]>;
	// 				return (
	// 					<Card
	// 						className="card-border-radius-14p card-small-padding "
	// 						key={sampleInstance.sampleInstanceId}
	// 					>
	// 						<InstanceInfoCardContent
	// 							company={company}
	// 							instance={sampleInstance}
	// 							batchType={batchType}
	// 							isBatched={false}
	// 							isSelectedAsVerifySample={
	// 								sampleInstance.sampleInstanceId === batchVerifyingSampleId
	// 							}
	// 							selectAsInstanceToVerify={() => {}}
	// 							selectedTestCategory={testCategory}
	// 							hierarchyNodeParentMap={hierarchyNodeParentMap}
	// 						></InstanceInfoCardContent>
	// 					</Card>
	// 				);
	// 			}
	// 	  )
	// 	: [];

	return (
		<>
			<div className={`batch-details-workflow-container`}>
				{workflowStepsContent}
				{currentStepComponent}
			</div>
		</>
	);
}
